import BaseRPCHandler from "./BaseRPCHandler";

export default class EthDecryptHandler extends BaseRPCHandler {
    constructor() {
        super('eth_decrypt');
    }
    async handle(provider, request) {

    }
}